import { Badge, Button, Divider, Space, Table } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  compareDates,
  compareStrings,
} from "../../../shared/table/sorterFunctions";

import { useNavigate } from "react-router-dom";
import {
  QUOTE_STATUSES_MAP,
  QUOTE_STATUS_DISPLAY,
  QUOTE_STATUS_FILTERS,
} from "../../../shared/constants";
import {
  getDateFilterProps,
  getTextFilterProps,
} from "../../../shared/table/filterFunctions";
import { setIsDownloading } from "../../../store/downloads/downloadsSlice";

const ApplicationsSearchTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const data = useSelector((state) => state.applicationsSearch.data);
  const isLoading = useSelector((state) => state.applicationsSearch.isLoading);

  useEffect(() => {
    dispatch(setIsDownloading(false));
  }, []);

  const columns = [
    {
      title: "Status",
      key: "quote_status",
      dataIndex: "quote_status",
      width: 110,
      // minWidth: 100,
      render: (status) => (
        <Badge
          status={QUOTE_STATUSES_MAP[status] || "error"}
          text={QUOTE_STATUS_DISPLAY[status] || status}
        />
      ),
      sorter: (a, b) => compareStrings(a, b, "quote_status"),
      filters: QUOTE_STATUS_FILTERS,
      onFilter: (value, record) => record.quote_status == value,
    },
    {
      title: "Insured Name",
      dataIndex: "main_owner_name",
      key: "main_owner_name",
      width: 150,
      sorter: (a, b) => compareStrings(a, b, "main_owner_name"),
      ...getTextFilterProps("main_owner_name", "Insured Name"),
    },
    {
      title: "Application Type",
      dataIndex: "application_type",
      key: "application_type",
      width: 170,
      filters: [
        {
          text: "First Application",
          value: "new",
        },
        {
          text: "Returning Application",
          value: "existing",
        },
        {
          text: "Renewal",
          value: "renewal",
        },
      ],
      onFilter: (value, record) => record.application_type === value,
      render: (value) => {
        switch (value) {
          case "new":
            return "First Application";
          case "existing":
            return "Returning Application";
          case "renewal":
            return "Renewal";
          default:
            return "Unknown";
        }
      },
      sorter: (a, b) => compareStrings(a, b, "application_type"),
    },
    {
      title: "Customer Code",
      dataIndex: "customer_code",
      key: "customer_code",
      width: 160,
      sorter: (a, b) => compareStrings(a, b, "customer_code"),
      ...getTextFilterProps("customer_code", "Customer Code"),
    },
    {
      title: "Aircraft",
      key: "aircraft",
      dataIndex: "aircraft",
      width: 212,
      sorter: (a, b) => compareStrings(a, b, "aircraft"),
      ...getTextFilterProps("aircraft", "Aircraft"),
    },
    {
      title: "Submission Date",
      key: "submission_date",
      dataIndex: "submission_date",
      width: 175,
      render: (data) => dayjs(data).format("YYYY-MM-DD hh:mm A"),
      sorter: (a, b) => compareDates(a, b, "submission_date"),
      ...getDateFilterProps("submission_date"),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      width: 185,
      render: (value, record) => {
        return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(
          6
        )} (${record.phone_type ?? "NAN"})`;
      },
      sorter: (a, b) => compareStrings(a, b, "phone"),
      ...getTextFilterProps("phone", "Phone"),
    },
    {
      key: "action",
      width: 130,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Space>
          {/* <Button
            size="small"
            type="link"
            loading={
              isDownloading && latestDownloadedRecord.current == record.id
            }
            disabled={
              isDownloading && latestDownloadedRecord.current != record.id
            }
            onClick={() => {
              latestDownloadedRecord.current = record.id;
              dispatch(
                downloadFile({
                  defaultName: "PrivateAviationForm",
                  url: `/private_aviation/forms/${record.id}/serve_pdf`,
                })
              );
            }}
          >
            Print
          </Button> */}
          <Button
            size="small"
            type="link"
            onClick={() => {
              navigate(`/applications/view/${record.id}`);
            }}
          >
            View
          </Button>
          <Divider type="vertical" style={{ marginLeft: 0, marginRight: 0 }} />
          <Button
            size="small"
            type="link"
            onClick={() => {
              navigate(`/applications/quote/${record.id}`);
            }}
          >
            Quote
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      size="small"
      scroll={{ x: 1160, y: 500 }}
      // virtual
      bordered
      sticky
      pagination={{ defaultPageSize: 50, pageSizeOptions: [10, 20, 50, 100] }}
      loading={isLoading}
    />
  );
};

export default ApplicationsSearchTable;
